import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJiraSoftwareLogoOutlined = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "currentColor",
	focusable: "false",
	"aria-hidden": "true",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M18.1713 -0.0405273L17.0684 0.760107C16.9991 0.810406 16.9393 0.869529 16.8722 0.922103C16.4231 1.27392 16.0234 1.67439 15.679 2.11527L2.04955 15.7447C0.817549 16.9771 0.817549 19.0233 2.04955 20.2557L17.8348 36.041L18.9376 35.2403C19.0069 35.19 19.0668 35.1309 19.1339 35.0783C19.5828 34.7265 19.9828 34.3261 20.3271 33.8852L33.9565 20.2557C35.1885 19.0233 35.1885 16.9771 33.9565 15.7447L18.1713 -0.0405273ZM18.0747 4.37386L31.7011 18.0002L21.5981 28.1032C21.3278 26.8256 20.8413 25.6052 20.1059 24.5299L26.6293 18.0065L19.271 10.5702C18.1893 9.45778 17.5367 8.00548 17.3956 6.46112C17.3846 5.6932 17.6641 4.99815 18.0747 4.37386ZM14.408 7.89728C14.6773 9.17448 15.1656 10.389 15.9002 11.4643C15.9007 11.4651 15.8997 11.4667 15.9002 11.4674L9.37052 17.994L16.7289 25.4302C17.8114 26.5409 18.4671 27.9928 18.6105 29.5362C18.622 30.3054 18.3426 31.0013 17.9314 31.6266L4.30503 18.0002L14.408 7.89728ZM18.028 13.8475L22.1308 17.994L17.9719 22.1529L13.869 18.0065L18.028 13.8475Z" })]
});
const ForwardRef = forwardRef(SvgJiraSoftwareLogoOutlined);
export { ForwardRef as ReactComponent };
